import React, { useEffect, useState } from 'react'
import {  X  } from "@phosphor-icons/react";
// import axios from 'axios';
import axiosInstance from '../../api/axiosInstance.js';
import { toast } from 'react-toastify';
import Lottie from "lottie-react";
import animationData from "../loader/page-loader.json";


export default function DeleteBookingModal(props) {
    
    const hotelId = localStorage.getItem("hotelId");
    const [load,setLoad] = useState(false);

    const closeModal = ()=>{
        try{
            props.setDeleteBookingModal(false);
            props.setDeleteBookingId("")
        }catch(error){
            console.log(error)
        }
    }


    const deleteBookingData = async()=>{
        try{
            setLoad(true);
            const response = await axiosInstance.delete(`/api/v1/hotels/${hotelId}/bookings/${props.deleteBookingId}`)
            toast.success("Booking deleted successfully");
            props.setSelectedBooking(null);
            props.setDeleteBookingModal(false);
            props.setDeleteBookingId("")
        }catch(error){
            toast.error("Failed to delete booking");
            console.log(error);
        }
        finally{
            setLoad(false);
        }

    }

    // const completeBooking = async()=>{
    //     try{
    //         setLoad(true);
    //         const bookingId = props.deleteBookingId;

    //         const response2 = await axiosInstance.get(`/api/v1/hotels/${hotelId}/bookings/${bookingId}`)
    //         console.log("Booking Data : ",response2.data);

    //         const bookingData = response2.data;
    //         console.log("Bookinf Data ;",bookingData?.checkin_date)

    //         const response1 = await axiosInstance.get(`/api/v1/hotels/${hotelId}/bookings/${bookingId}/booked-rooms`);
    //         console.log("Booked ROoms : ",response1.data.data);
            
    //         const data = response1.data.data;

    //         if(Array.isArray(data)){
    //             for(let i=0;i<data.length;i++){
    //                 const formData = {
    //                     number_of_guests : data[i]?.guests?.length || 0,
    //                     checkin_date: data[i]?.checkin_date || bookingData?.checkin_date || "",
    //                     checkout_date: data[i]?.checkout_date || bookingData?.checkout_date || "",
    //                     room_number: data[i]?.room_number,
    //                     guest_details: data[i].guests,
    //                     payment_status : "SUCCESSFUL"
    //                 }
    //                 // if ((data[i].checkin_date === "" || data[i].checkin_date == null) || (data[i].checkout_date === "" || data[i].checkout_date == null)) {
    //                 //     toast.error("Check In Date or Check out Date Missing Please Update....");
    //                 //     return;
    //                 // }
    //                 const response = await axiosInstance.put(
    //                     `/api/v1/hotels/${hotelId}/bookings/${bookingId}/booked-rooms/${data[i]?.id}`,formData
    //                 );
    //             }
    //         }
    //         toast.success("Booking Deleted Successfully");

 
    //         props.setDeleteBookingModal(false);
    //         props.setDeleteBookingId("")

    //     }catch(error){
    //         toast.error(`Error Occured : ${error?.response?.data?.message || "Something went wrong"}`);
    //         console.log(error);
    //     }
    //     finally{
    //         setLoad(false);
    //     }
    // }

  return (
    <>
        {
            load && (
                <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-20 z-[1002]">
                <Lottie
                    animationData={animationData}
                    loop={true}
                    style={{ width: 100, height: 100 }}
                />
                </div>
            )
        }
        <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-60 flex items-center justify-center z-[1001]">
            <div className="pastBookingCard bg-white w-1/2 overflow-y-auto rounded-md" style={{ height: "fit-content" }}>

                {/* Check Out Room Header */}
                <div className="py-2 flex justify-between items-center p-2 border-b border-[#BFC4CC]">
                    <h2 className="text-2xl text-[#262B33] tracking-[6px]">
                        DELETE BOOKING 
                    </h2>
                    <span className="bg-[#EEF0FB] p-2 rounded-md border-md cursor-pointer" 
                    onClick={()=>closeModal()}
                    >
                        <X className="text-[#343330]" />
                    </span>
                </div>

                {/* CheckOut Room Content */}
                <div className="p-8">
                    <div className="text-center">
                        <h4 className='text-xl'>
                            Are You Sure You Want to Delete this Booking ?
                        </h4>
                    </div>
                    <div className='flex gap-4 mt-10'>
                        <button className='w-full p-2 bg-[#FF7378] rounded-md'  onClick={()=>deleteBookingData()}>Yes</button>
                        <button className='w-full p-2 bg-[#0B22B2] rounded-md text-white'
                            onClick={()=>closeModal()}
                        >No</button>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}
